export const LIST_SEARCH = 'LIST_SEARCH';
export const LIST_PAGE = 'LIST_PAGE';
export const LIST_STARTDATE = 'LIST_STARTDATE';
export const LIST_ENDDATE = 'LIST_ENDDATE';